var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.debugMode ? 'DebugLayout' : 'Layout', {
    tag: "component"
  }, [_c('div', {
    ref: "myInfoPage"
  }, [_vm.loading || _vm.error ? _c('LoaderIcon', {
    staticClass: "m-auto",
    attrs: {
      "error": _vm.error
    }
  }) : _c('div', [_c('BaseTitle', [_vm._v(_vm._s(_vm.pageTitle))]), _c('TabContainer', {
    ref: "tabContainer",
    class: _vm.$style.tabContainer,
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        var _class;
        return [_vm.tabSelected === 'my-info' || _vm.tabSelected === 'user' ? _c('div', [_c('TabContentContainer', {
          class: [_vm.$style.firstTabMargin, _vm.isRightmostTabOpen ? _vm.$style.lastContentTabOpen : '']
        }, [_c('div', {
          class: _vm.$style.overviewContainer
        }, [_c('div', {
          class: _vm.$style.profilePictureContainer
        }, [_c('div', {
          staticStyle: {
            "position": "relative",
            "width": "min-content",
            "margin": "0 auto"
          }
        }, [_c('PictureUpload', {
          class: _vm.$style.profilePictureUpload,
          attrs: {
            "editable": !_vm.selectedUserId,
            "user-id": _vm.getUser.id
          },
          on: {
            "update-photo": _vm.updatePhotoUrl
          }
        }), _c('div', {
          class: _vm.$style.profilePictureImgWrapper
        }, [_c('img', {
          class: (_class = {}, _class[_vm.$style.profilePictureImg] = true, _class),
          attrs: {
            "alt": "My Profile Picture",
            "src": _vm.picturePath
          },
          on: {
            "error": function error($event) {
              _vm.errorLoading = true;
            }
          }
        })])], 1), _c('h2', {
          staticClass: "color-secondary-green text-center mt-3 mb-0"
        }, [_vm._v(_vm._s(_vm.getUser.name))]), _vm.getUser.jobTitle ? _c('h3', {
          staticClass: "color-secondary-green font-weight-normal text-center mt-1"
        }, [_vm._v(" " + _vm._s(_vm.getUser.jobTitle) + " ")]) : _vm._e(), _vm._l(_vm._.take(_vm.getUser.groupLabels, 3), function (label) {
          return _c('p', {
            key: label,
            staticClass: "button-text color-primary-blue text-center"
          }, [_vm._v(" " + _vm._s(label) + " ")]);
        }), _vm.getUser.groupLabels.length === 4 ? [_c('p', {
          staticClass: "button-text color-primary-blue text-center"
        }, [_vm._v(_vm._s(_vm.getUser.groupLabels[3]))])] : _vm.getUser.groupLabels.length > 4 ? [_c('p', {
          staticClass: "width-fit-content mx-auto button-text color-primary-blue text-center",
          attrs: {
            "id": "show-more-roles-tooltip"
          }
        }, [_vm._v(" + " + _vm._s(_vm.getUser.groupLabels.length - 3) + " more ")]), _c('b-tooltip', {
          attrs: {
            "target": "show-more-roles-tooltip",
            "placement": "bottom",
            "custom-class": "tooltipBlue",
            "no-fade": ""
          }
        }, _vm._l(_vm._.slice(_vm.getUser.groupLabels, 3), function (label) {
          return _c('p', {
            key: label,
            staticClass: "color-white text-center"
          }, [_vm._v(" " + _vm._s(label) + " ")]);
        }), 0)] : _vm._e()], 2), _c('div', {
          staticClass: "d-flex flex-grow-1 flex-min-width"
        }, [_c('div', {
          class: _vm.$style.divider
        }), _c('div', {
          staticClass: "flex-grow-1"
        }, [_c('div', {
          staticClass: "d-flex justify-content-end"
        }, [!_vm.selectedUserId ? _c('div', {
          class: _vm.$style.editIconContainerAbsolute,
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.openUserPmModal('overview');
            }
          }
        }, [_c('MottoIcon', {
          class: _vm.$style.editIcon,
          attrs: {
            "name": "PenToSquare",
            "icon-color": "primary"
          }
        })], 1) : _vm._e()]), _c('FormItemGroup', [_c('FormItemPhone', {
          attrs: {
            "phone-label": "Work Line",
            "phone": _vm.getUser.phone,
            "phone-ext": _vm.getUser.phoneExt,
            "rules": "required|validPhoneNumber"
          },
          on: {
            "update:phone": function updatePhone($event) {
              return _vm.$set(_vm.getUser, "phone", $event);
            },
            "update:phoneExt": function updatePhoneExt($event) {
              return _vm.$set(_vm.getUser, "phoneExt", $event);
            },
            "update:phone-ext": function updatePhoneExt($event) {
              return _vm.$set(_vm.getUser, "phoneExt", $event);
            }
          }
        }), _c('FormItemPhone', {
          attrs: {
            "phone-label": "Mobile Number",
            "phone": _vm.getUser.phoneMobile,
            "phone-ext": _vm.getUser.phoneMobileExt,
            "phone-ext-label": "Ext. Mobile",
            "rules": "validPhoneNumber"
          },
          on: {
            "update:phone": function updatePhone($event) {
              return _vm.$set(_vm.getUser, "phoneMobile", $event);
            },
            "update:phoneExt": function updatePhoneExt($event) {
              return _vm.$set(_vm.getUser, "phoneMobileExt", $event);
            },
            "update:phone-ext": function updatePhoneExt($event) {
              return _vm.$set(_vm.getUser, "phoneMobileExt", $event);
            }
          }
        })], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Motto Email",
            "value": _vm.getUser.primaryEmail
          }
        })], 1), _c('FormItemGroup', [!_vm.getUser.secondaryEmailTemp ? _c('FormItem', {
          attrs: {
            "label": "Personal Email",
            "value": _vm.getUser.secondaryEmail,
            "rules": "required"
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.getUser, "secondaryEmail", $event);
            }
          }
        }) : _vm._e(), _vm.getUser.secondaryEmailTemp ? _c('FormItem', {
          attrs: {
            "label": "Personal Email",
            "value": _vm.getUser.secondaryEmailTemp,
            "tooltip-text": 'A confirmation has been sent to your personal email. Please verify your email address.'
          }
        }) : _vm._e()], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Time Zone",
            "rules": 'required',
            "edit-select-values": _vm.getTimeZoneOptions,
            "value": _vm.timezoneOptions[_vm.getUser.timeZone]
          }
        }), _c('FormItemBirthDay', {
          attrs: {
            "birth-day": _vm.getUser.birthDay,
            "birth-month": _vm.getUser.birthMonth
          },
          on: {
            "update:birthDay": function updateBirthDay($event) {
              return _vm.$set(_vm.getUser, "birthDay", $event);
            },
            "update:birth-day": function updateBirthDay($event) {
              return _vm.$set(_vm.getUser, "birthDay", $event);
            },
            "update:birthMonth": function updateBirthMonth($event) {
              return _vm.$set(_vm.getUser, "birthMonth", $event);
            },
            "update:birth-month": function updateBirthMonth($event) {
              return _vm.$set(_vm.getUser, "birthMonth", $event);
            }
          }
        })], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Start Date",
            "value": _vm.formatDate(_vm.getUser.createdAt, 'YYYY-MM-DD', 'MM/DD/yyyy')
          }
        }), _vm.getUser.isInactive && _vm.getUser.deactivateDate ? _c('FormItem', {
          attrs: {
            "label": "Termination Date",
            "value": _vm.formatDate(_vm.getUser.deactivateDate, 'YYYY-MM-DD', 'MM/DD/yyyy')
          }
        }) : _vm._e()], 1)], 1)])])]), _vm.getUser.groupLabels.some(function (x) {
          return x.includes('MLO');
        }) ? _c('TabContentContainer', {
          attrs: {
            "flex-columns-width": 230
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref) {
              var flexColumnsPerRow = _ref.flexColumnsPerRow;
              return [_c('div', [_c('div', {
                class: _vm.$style.titleContainerWithButton
              }, [_c('h1', {
                class: _vm.$style.tabTitle
              }, [_vm._v("Licensing")]), !_vm.selectedUserId && _vm.getUser.groupLabels.some(function (x) {
                return x.includes('MLO Phase 2');
              }) && !_vm.getUser.isLicenseChangePending ? _c('BaseButton', {
                attrs: {
                  "options": {
                    defaultPadding: true
                  },
                  "theme": "blue"
                },
                on: {
                  "click": function click($event) {
                    $event.stopPropagation();
                    return _vm.openUserPmModal('request_licenses');
                  }
                }
              }, [_vm._v(" Request State License ")]) : _vm._e()], 1), _c('div', {
                staticClass: "mt-4"
              }, [_c('FormItemGroup', [_c('PersonnelFormLicenseStates', {
                attrs: {
                  "label": "State(s) of Licensure",
                  "value": _vm.getUserLicensesWithPending
                }
              }), _c('div', {
                directives: [{
                  name: "show",
                  rawName: "v-show",
                  value: flexColumnsPerRow > 2,
                  expression: "flexColumnsPerRow > 2"
                }]
              }), _c('FormItem', {
                attrs: {
                  "label": "NMLS",
                  "value": _vm.getUser.nmlsNumber
                }
              })], 1)], 1)])];
            }
          }], null, false, 2919238448)
        }) : _vm._e(), _c('TabContentContainer', {
          class: !_vm.openedSections.includes("".concat(_vm.getUser.id, "social-media")) ? _vm.$style.closedSection : '',
          nativeOn: {
            "click": function click($event) {
              return function () {
                _vm.openedSections = [].concat(_vm.openedSections, ["".concat(_vm.getUser.id, "social-media")]);
              }.apply(null, arguments);
            }
          }
        }, [_c('div', [_c('div', {
          staticClass: "d-flex justify-content-between align-items-center"
        }, [_c('h1', {
          class: _vm.$style.tabTitle
        }, [_vm._v(" Social Media "), !_vm.openedSections.includes("".concat(_vm.getUser.id, "social-media")) ? _c('BaseIcon', {
          class: _vm.$style.closeSectionArrow,
          attrs: {
            "name": "chevron-down"
          }
        }) : _c('BaseIcon', {
          class: _vm.$style.closeSectionArrow,
          attrs: {
            "name": "chevron-up"
          },
          nativeOn: {
            "click": function click($event) {
              $event.stopPropagation();
              return function () {
                _vm.openedSections = _vm.openedSections.filter(function (x) {
                  return x !== "".concat(_vm.getUser.id, "social-media");
                });
              }.apply(null, arguments);
            }
          }
        })], 1), !_vm.selectedUserId ? _c('div', {
          class: _vm.$style.editIconContainer,
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.openUserPmModal('marketing');
            }
          }
        }, [_c('MottoIcon', {
          class: _vm.$style.editIcon,
          attrs: {
            "name": "PenToSquare",
            "icon-color": "primary"
          }
        })], 1) : _vm._e()]), _vm.openedSections.includes("".concat(_vm.getUser.id, "social-media")) ? _c('div', {
          staticClass: "mt-4"
        }, [_c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Facebook",
            "placeholder": "facebook.com",
            "value": _vm.getUser.facebook
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.getUser, "facebook", $event);
            }
          }
        }), _c('FormItem', {
          attrs: {
            "label": "Twitter",
            "placeholder": "twitter.com",
            "value": _vm.getUser.twitter
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.getUser, "twitter", $event);
            }
          }
        }), _c('FormItem', {
          attrs: {
            "label": "LinkedIn",
            "placeholder": "linkedin.com",
            "value": _vm.getUser.linkedin
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.getUser, "linkedin", $event);
            }
          }
        })], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Instagram",
            "placeholder": "instagram.com",
            "value": _vm.getUser.instagram
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.getUser, "instagram", $event);
            }
          }
        }), _c('FormItem', {
          attrs: {
            "label": "Snapchat",
            "placeholder": "snapchat.com",
            "value": _vm.getUser.snapchat
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.getUser, "snapchat", $event);
            }
          }
        }), _c('div')], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Website",
            "copyable": "",
            "placeholder": "Website",
            "value": _vm.getUser.domain
          }
        }), _c('FormItem', {
          attrs: {
            "label": "Application URL",
            "copyable": "",
            "placeholder": "Application URL",
            "value": _vm.getUser.mortgageApplicLink
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.getUser, "mortgageApplicLink", $event);
            }
          }
        }), _c('FormItem', {
          attrs: {
            "label": "Google My Business",
            "placeholder": "google.com",
            "value": _vm.getUser.google
          }
        })], 1), _c('FormItemGroup', [_c('FormItemAddMultiple', {
          attrs: {
            "input-container-class": _vm.$style.keywordsInput,
            "value": _vm.getUser.keywords,
            "label": "SEO Keywords",
            "placeholder": "Add Keyword"
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.getUser, "keywords", $event);
            }
          }
        })], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "ORM Location Description",
            "placeholder": "ORM Location Description",
            "tooltip-text": "The following will be used to fill in any website listing descriptions on websites such as Google, Bing, Yelp, and many more. If you would like something else please enter your own description below.  Limit is 750 characters.",
            "value": _vm.getUser.locationDetails,
            "rules": "max:750"
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.getUser, "locationDetails", $event);
            }
          }
        })], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Short Web Description",
            "placeholder": "Short Web Description",
            "tooltip-text": "Add a short description of your business that will appear across the web where a short business description is available with your populated information.  Limit is 100 characters.",
            "value": _vm.getUser.shortDescription,
            "rules": "max:100"
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.getUser, "shortDescription", $event);
            }
          }
        })], 1)], 1) : _vm._e()])]), _c('TabContentContainer', {
          class: !_vm.openedSections.includes("".concat(_vm.getUser.id, "notifications")) ? _vm.$style.closedSection : '',
          nativeOn: {
            "click": function click($event) {
              return function () {
                _vm.openedSections = [].concat(_vm.openedSections, ["".concat(_vm.getUser.id, "notifications")]);
              }.apply(null, arguments);
            }
          }
        }, [_c('div', [_c('div', {
          staticClass: "d-flex justify-content-between align-items-center"
        }, [_c('h1', {
          class: _vm.$style.tabTitle
        }, [_vm._v(" Notifications "), !_vm.openedSections.includes("".concat(_vm.getUser.id, "notifications")) ? _c('BaseIcon', {
          class: _vm.$style.closeSectionArrow,
          attrs: {
            "name": "chevron-down"
          }
        }) : _c('BaseIcon', {
          class: _vm.$style.closeSectionArrow,
          attrs: {
            "name": "chevron-up"
          },
          nativeOn: {
            "click": function click($event) {
              $event.stopPropagation();
              return function () {
                _vm.openedSections = _vm.openedSections.filter(function (x) {
                  return x !== "".concat(_vm.getUser.id, "notifications");
                });
              }.apply(null, arguments);
            }
          }
        })], 1), !_vm.selectedUserId ? _c('div', {
          class: _vm.$style.editIconContainer,
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.openUserPmModal('notifications');
            }
          }
        }, [_c('MottoIcon', {
          class: _vm.$style.editIcon,
          attrs: {
            "name": "PenToSquare",
            "icon-color": "primary"
          }
        })], 1) : _vm._e()]), _vm.openedSections.includes("".concat(_vm.getUser.id, "notifications")) ? _c('div', {
          staticClass: "mt-4"
        }, [_vm.hasSmsPromptsFeature ? _c('div', {
          staticClass: "mb-4"
        }, [_c('div', [_c('h3', [_vm._v("SMS")]), _c('div', {
          staticClass: "ml-3"
        }, [_c('h4', {
          staticClass: "font-weight-bold"
        }, [_vm._v("MottoMortgage Network Alerts")]), _c('p', {
          staticClass: "p1"
        }, [_vm._v(" Opt in to receive important messages regarding marketing, events, and general information about tools, services, and support of the Motto Mortgage network. Message frequency varies. Text HELP to 58476 or call 866-668-8660 for help, STOP to 58476 to end. Message and Data rates may apply. By opting in, you authorize Motto Mortgage to deliver marketing messages using an automatic telephone dialing system. You are not required to opt in as a condition of purchasing any property, goods, or services. By checking the box below, you agree to the "), _c('RouterLink', {
          staticClass: "button-text text-decoration-none color-primary-blue",
          attrs: {
            "to": {
              name: 'mobileTerms'
            },
            "target": "_blank"
          }
        }, [_vm._v("MOBILE TERMS OF USE")]), _vm._v(" and "), _c('a', {
          staticClass: "button-text text-decoration-none color-primary-blue",
          attrs: {
            "href": "https://www.mottomortgage.com/privacy-policy",
            "target": "_blank"
          }
        }, [_vm._v("Motto Mortgage Privacy Policy")]), _vm._v(" and "), _c('RouterLink', {
          staticClass: "button-text text-decoration-none color-primary-blue",
          attrs: {
            "to": {
              name: 'userAgreement'
            },
            "target": "_blank"
          }
        }, [_vm._v("USER AGREEMENT")]), _vm._v(". ")], 1), _c('div', {
          staticClass: "d-flex mt-3 align-items-center",
          class: _vm.$style.optInMobileNumberContainer
        }, [_c('BaseCheckbox', {
          attrs: {
            "disabled": "",
            "label": "I’d like to receive text messages from Motto HQ.",
            "input-value": "1"
          },
          model: {
            value: _vm.acceptedMobileOptInData,
            callback: function callback($$v) {
              _vm.acceptedMobileOptInData = $$v;
            },
            expression: "acceptedMobileOptInData"
          }
        })], 1)])])]) : _vm._e(), _c('div', {
          staticClass: "mb-4"
        }, [_c('h3', [_vm._v("Email")]), _c('div', {
          staticClass: "ml-3"
        }, [_c('h4', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Network Connect")]), _c('div', [_c('p', {
          staticClass: "p1"
        }, [_vm._v(" Opt-in to receive email notifications for Network Connect deal-level referrals. ")])]), _c('div', {
          staticClass: "d-flex mt-3 align-items-center",
          class: _vm.$style.optInMobileNumberContainer
        }, [_c('BaseCheckbox', {
          attrs: {
            "disabled": "",
            "label": "Deal-level referral email notifications",
            "input-value": "1"
          },
          model: {
            value: _vm.emailNotificationReferral,
            callback: function callback($$v) {
              _vm.emailNotificationReferral = $$v;
            },
            expression: "emailNotificationReferral"
          }
        })], 1)])])]) : _vm._e()])])], 1) : _vm._e(), _vm.tabSelected === 'office' ? _c('div', [_c('TabContentContainer', {
          class: [_vm.$style.firstTabMargin, _vm.isRightmostTabOpen ? _vm.$style.lastContentTabOpen : '']
        }, [_c('div', {
          class: _vm.$style.officeOverviewContainer
        }, [_c('div', {
          class: _vm.$style.officeOverviewDataContainer,
          attrs: {
            "data-tour-office-data": ""
          }
        }, [_c('div', {
          staticClass: "flex-grow-1"
        }, [_c('h1', {
          staticClass: "break-word color-primary-blue"
        }, [_vm._v(" Motto Mortgage "), _c('br'), _vm._v(" " + _vm._s(_vm.getOffice.tradeName) + " ")]), _c('div', {
          staticClass: "mt-4 mb-4"
        }, [_c('h3', {
          staticClass: "color-primary-blue"
        }, [_vm._v(_vm._s(_vm.getOffice.addressStreet))]), _c('h3', {
          staticClass: "color-primary-blue"
        }, [_vm._v(_vm._s(_vm.getOffice.getStateAddress()))])]), _c('FormItemGroup', {
          attrs: {
            "item-min-width": 160
          }
        }, [_c('FormItem', {
          attrs: {
            "label": "Office Open Date",
            "value": _vm.getOffice.actualOpenDate ? _vm.formatDate(_vm.getOffice.actualOpenDate, 'YYYY-MM-DD', 'MM/DD/yyyy') : ''
          }
        }), _c('FormItem', {
          attrs: {
            "label": "Office Main Contact",
            "value": _vm.getOffice.mainContactName,
            "tooltip-text": "The Main Office Contact is not published on the web, and only serves as the main point of contact between your Office and Motto HQ."
          }
        })], 1), _c('FormItemGroup', {
          attrs: {
            "item-min-width": 160
          }
        }, [_c('FormItemPhone', {
          attrs: {
            "phone-label": "Office Phone",
            "phone": _vm.getOffice.phone,
            "phone-ext": _vm.getOffice.phoneExt
          },
          on: {
            "update:phone": function updatePhone($event) {
              return _vm.$set(_vm.getOffice, "phone", $event);
            },
            "update:phoneExt": function updatePhoneExt($event) {
              return _vm.$set(_vm.getOffice, "phoneExt", $event);
            },
            "update:phone-ext": function updatePhoneExt($event) {
              return _vm.$set(_vm.getOffice, "phoneExt", $event);
            }
          }
        }), _vm.getOffice.terminationDate && _vm.getOffice.status !== 'Open' && _vm.getOffice.status !== 'To Be Opened' ? _c('FormItem', {
          attrs: {
            "label": "Office Closed Date",
            "value": _vm.formatDate(_vm.getOffice.terminationDate, 'YYYY-MM-DD', 'MM/DD/yyyy')
          }
        }) : _vm._e()], 1)], 1), _vm.getOffice.primaryOpsContact ? [_c('p', {
          staticClass: "color-dark-gray mt-10 mb-10"
        }, [_vm._v("Motto HQ contact:")]), _c('PrimaryOpsContactPill', {
          attrs: {
            "primary-ops-contact": _vm.getOffice.primaryOpsContact
          }
        })] : _vm._e()], 2), _c('div', {
          class: _vm.$style.officeOverviewGraphContainer
        }, [_c('div', {
          class: _vm.$style.graphDivider
        }), _c('div', {
          class: _vm.$style.officeGraphsContainer,
          attrs: {
            "data-tour-office-graph": ""
          }
        }, [_c('YtdLoGraph', {
          attrs: {
            "office": _vm.getOffice,
            "users": _vm.getOfficeGraphUsers,
            "loan-production-data": _vm.loanProductionData[_vm.getOffice.id],
            "periods": _vm.leaderboardPeriods
          },
          on: {
            "click-user-picture": function clickUserPicture(user) {
              return _vm.viewProfileUserRosterPill(user, true);
            }
          }
        })], 1)])])]), _c('TabContentContainer', {
          class: !_vm.openedSections.includes("".concat(_vm.getOffice.id, "licensing")) ? _vm.$style.closedSection : '',
          nativeOn: {
            "click": function click($event) {
              return function () {
                _vm.openedSections = [].concat(_vm.openedSections, ["".concat(_vm.getOffice.id, "licensing")]);
              }.apply(null, arguments);
            }
          }
        }, [_c('div', [_c('div', {
          class: _vm.$style.titleContainerWithButton
        }, [_c('h1', {
          class: _vm.$style.tabTitle
        }, [_vm._v(" Licensing "), !_vm.openedSections.includes("".concat(_vm.getOffice.id, "licensing")) ? _c('BaseIcon', {
          class: _vm.$style.closeSectionArrow,
          attrs: {
            "name": "chevron-down"
          }
        }) : _c('BaseIcon', {
          class: _vm.$style.closeSectionArrow,
          attrs: {
            "name": "chevron-up"
          },
          nativeOn: {
            "click": function click($event) {
              $event.stopPropagation();
              return function () {
                _vm.openedSections = _vm.openedSections.filter(function (x) {
                  return x !== "".concat(_vm.getOffice.id, "licensing");
                });
              }.apply(null, arguments);
            }
          }
        })], 1), _c('div', {
          attrs: {
            "data-closed-section-button": ""
          }
        }, [_vm.canOfficeRequestLicense ? _c('BaseButton', {
          attrs: {
            "data-tour-office-request-license": "",
            "options": {
              defaultPadding: true
            },
            "theme": "blue"
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.openOfficePmModal('request_licenses');
            }
          }
        }, [_vm._v(" Request State License ")]) : _vm._e()], 1)]), _vm.openedSections.includes("".concat(_vm.getOffice.id, "licensing")) ? _c('div', {
          staticClass: "mt-4"
        }, [_c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "License Status",
            "value": _vm.getOffice.licensingStatus
          }
        }), _c('FormItem', {
          attrs: {
            "label": "NMLS",
            "value": _vm.getOffice.entityNMLS
          }
        })], 1), _c('FormItemGroup', [_c('PersonnelFormLicenseStates', {
          attrs: {
            "label": "State(s) of Licensure",
            "value": _vm.getOfficeLicensesWithPending
          }
        })], 1)], 1) : _vm._e()])]), _c('TabContentContainer', {
          class: !_vm.openedSections.includes("".concat(_vm.getOffice.id, "website")) ? _vm.$style.closedSection : '',
          nativeOn: {
            "click": function click($event) {
              return function () {
                _vm.openedSections = [].concat(_vm.openedSections, ["".concat(_vm.getOffice.id, "website")]);
              }.apply(null, arguments);
            }
          }
        }, [_c('div', {
          attrs: {
            "data-tour-office-website": ""
          }
        }, [_c('div', {
          staticClass: "d-flex justify-content-between align-items-center",
          class: !_vm.getOffice.isIntegratedWithLHP ? _vm.$style.titleContainerWithButton : ''
        }, [_c('h1', {
          class: _vm.$style.tabTitle
        }, [_vm._v(" Website "), !_vm.openedSections.includes("".concat(_vm.getOffice.id, "website")) ? _c('BaseIcon', {
          class: _vm.$style.closeSectionArrow,
          attrs: {
            "name": "chevron-down"
          }
        }) : _c('BaseIcon', {
          class: _vm.$style.closeSectionArrow,
          attrs: {
            "name": "chevron-up"
          },
          nativeOn: {
            "click": function click($event) {
              $event.stopPropagation();
              return function () {
                _vm.openedSections = _vm.openedSections.filter(function (x) {
                  return x !== "".concat(_vm.getOffice.id, "website");
                });
              }.apply(null, arguments);
            }
          }
        })], 1), !_vm.getOffice.isReadOnly && _vm.getOffice.isIntegratedWithLHP ? _c('div', {
          class: _vm.$style.editIconContainer,
          on: {
            "click": function click($event) {
              return _vm.openOfficePmModal('website');
            }
          }
        }, [_c('MottoIcon', {
          class: _vm.$style.editIcon,
          attrs: {
            "name": "PenToSquare",
            "icon-color": "primary"
          }
        })], 1) : !_vm.getOffice.isReadOnly ? _c('BaseButton', {
          attrs: {
            "options": {
              defaultPadding: true
            },
            "theme": "blue"
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
              return _vm.openNewWebsitePaperform.apply(null, arguments);
            }
          }
        }, [_vm._v(" Activate Website ")]) : _vm._e()], 1), _vm.openedSections.includes("".concat(_vm.getOffice.id, "website")) ? _c('div', {
          staticClass: "mt-4"
        }, [_c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Website",
            "copyable": "",
            "value": _vm.getOffice.website
          }
        })], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Vanity Url",
            "copyable": "",
            "value": _vm.getOffice.vanityUrl
          }
        })], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Web Admin",
            "value": _vm.getSelectedWebAdmin.name,
            "tooltip-text": "The Website Admin designation grants this user access to the main office website admin settings.  Only one user may be designated as the Website Admin at this time."
          }
        })], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "ORM Business Description",
            "value": _vm.getOffice.locationDetails,
            "tooltip-text": "This description appears on the main office website in the About Us section, and on listings such as Google My Business. ",
            "rules": 'required|max:750'
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.getOffice, "locationDetails", $event);
            }
          }
        })], 1), _c('FormItemGroup', [_c('FormItem', {
          attrs: {
            "label": "Short Web Description",
            "value": _vm.getOffice.shortDescription,
            "rules": "max:100",
            "tooltip-text": "Add a short description of your business that will appear across the web where a short business description is available with your populated information.  Limit is 100 characters."
          },
          on: {
            "update:value": function updateValue($event) {
              return _vm.$set(_vm.getOffice, "shortDescription", $event);
            }
          }
        })], 1)], 1) : _vm._e()])]), _c('TabContentContainer', [_c('div', [_c('div', {
          class: _vm.$style.titleContainerWithButton
        }, [_c('h1', {
          class: _vm.$style.tabTitle
        }, [_vm._v("Roster")]), !_vm.getOffice.isReadOnly ? _c('RouterLink', {
          staticClass: "router-link-anchor",
          attrs: {
            "data-tour-add-new-user": "",
            "to": {
              name: 'personnel-management-user-creation'
            }
          }
        }, [_c('BaseButton', {
          attrs: {
            "theme": "blue"
          }
        }, [_vm._v("Add New User")])], 1) : _vm._e()], 1)]), _c('div', {
          staticClass: "mt-4",
          class: _vm.$style.officeRosterUserContainer
        }, _vm._l(_vm.getRosterForOffice(_vm.getOffice, {
          onlyActive: true
        }), function (officeUser) {
          return _c('UserRosterPill', {
            key: officeUser.id,
            attrs: {
              "data-tour-user-roster-pill": "",
              "user": officeUser,
              "read-only": _vm.getOffice.isReadOnly
            },
            on: {
              "update-role": _vm.updateRoleRosterPill,
              "deactivate-user": _vm.deactivateUserRosterPill,
              "view-profile": _vm.viewProfileUserRosterPill
            }
          });
        }), 1), _c('SimpleDivider', {
          attrs: {
            "margin-x": 0,
            "margin-y": 50
          }
        }), _c('div', {
          class: _vm.$style.officeRosterUserContainer
        }, _vm._l(_vm.getRosterForOffice(_vm.getOffice, {
          onlyInactive: true
        }), function (officeUser) {
          return _c('UserRosterPill', {
            key: officeUser.id,
            attrs: {
              "user": officeUser,
              "read-only": _vm.getOffice.isReadOnly
            },
            on: {
              "update-role": _vm.updateRoleRosterPill,
              "deactivate-user": _vm.deactivateUserRosterPill,
              "view-profile": _vm.viewProfileUserRosterPill
            }
          });
        }), 1)], 1)], 1) : _vm._e()];
      },
      proxy: true
    }])
  }, [_c('b-nav', {
    staticClass: "mw-100 width-fit-content motto-tabs align-items-end motto-tabs-mobile-100 mt-4",
    attrs: {
      "data-tour-tabs": "",
      "tabs": ""
    },
    on: {
      "mouseenter": _vm.setTabHoverTimeout,
      "mouseleave": _vm.clearTabHoverTimeout
    }
  }, _vm._l(_vm.getTabs, function (tab) {
    return _c('b-nav-item', {
      key: tab.tabName + tab.id,
      ref: tab.tabName + tab.id,
      refInFor: true,
      class: _vm.getTabClass(tab),
      attrs: {
        "id": tab.tabName + tab.id,
        "data-my-info-tab": "",
        "href": "javascript:;",
        "active": _vm.isTabActive(tab.tabName, tab.id)
      },
      on: {
        "click": function click($event) {
          return _vm.openTab(tab.tabName, tab.id);
        }
      }
    }, [_c('span', {
      staticClass: "motto-tabs-label"
    }, [_c('BaseIcon', {
      staticClass: "mr-1",
      attrs: {
        "name": tab.tabName === 'office' ? 'building' : tab.tabName === 'user' ? 'building-user' : 'user'
      }
    }), _vm._v(" " + _vm._s(tab.label) + " ")], 1), tab.tabName === 'user' ? _c('span', {
      staticClass: "motto-tabs-close-X",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.closeTab(tab.tabName, tab.id);
        }
      }
    }, [_c('MottoIcon', {
      attrs: {
        "name": "X",
        "icon-color": "gray"
      }
    })], 1) : _vm._e(), _c('b-tooltip', {
      attrs: {
        "target": tab.tabName + tab.id,
        "placement": "top",
        "no-fade": "",
        "triggers": "hover",
        "custom-class": _vm.shouldShowHoverTooltipTab ? "pe-none tooltipGray light-transparent d-none d-lg-block" : "d-none"
      }
    }, [_c('p', {
      staticClass: "color-darkest-gray overline-text font-weight-bold"
    }, [_vm._v(_vm._s(tab.label))])])], 1);
  }), 1)], 1), _c('div', {
    class: _vm.$style.helpButtonContainer,
    attrs: {
      "data-tour-help-button": ""
    }
  }, [_c('h4', {
    staticClass: "text-center color-primary-charcoal font-weight-bold"
  }, [_vm._v("Need help updating your information?")]), _c('BaseButton', {
    attrs: {
      "theme": "lightBlue"
    },
    on: {
      "click": _vm.openTicket
    }
  }, [_c('span', [_vm._v("Submit a ticket")])])], 1)], 1), _c('ModalUserPmForm', {
    attrs: {
      "user-to-edit": _vm.getUser,
      "primary-office-licenses": _vm.getUserPrimaryOfficeLicenses,
      "form": _vm.currentModalUserPmForm,
      "custom-class": _vm.currentModalUserPmForm === 'request_licenses' ? 'form-modal-small' : ''
    },
    on: {
      "update-user": _vm.updateEditedUser
    }
  }), _c('ModalOfficePmForm', {
    attrs: {
      "office-to-edit": _vm.getOffice,
      "form": _vm.currentModalOfficePmForm,
      "custom-class": _vm.currentModalOfficePmForm === 'request_licenses' ? 'form-modal-small' : ''
    },
    on: {
      "update-office": _vm.updateEditedOffice
    }
  }), _c('ModalDeactivationPersonnel', {
    attrs: {
      "user": _vm.getUser
    },
    on: {
      "update-user": _vm.updateUserVariable
    }
  }), _vm.hasTour && _vm.canUserManagePersonnel && !_vm.isMobile ? _c('TutorialStartButton', {
    attrs: {
      "start-tutorial-fn": _vm.startOfficePersonnelTutorial
    }
  }) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }